import { BRAND_PROPERTIES } from 'constants/brand';
import { operatingCountries } from 'constants/user';
import { PRICE_UNAVAILABLE_ERROR, ERRONEOUS_PRICE_ERROR } from 'constants/globalPrice';

/**
 * Derive price effective date from brand properties
 * @param {Map} currentBrand
 * @returns priceEffectiveDate
 */
export const getPriceEffectiveDate = (currentBrand) => {
  if (!currentBrand) return '';
  const priceEffectiveDateObj = currentBrand.get('brandProperties')[BRAND_PROPERTIES.GLOBAL_PRICE_EFFECTIVE_DATE] || {};
  // TODO: use propertyValue after refactoring backend to save PriceEffectiveDate as timestamp
  return priceEffectiveDateObj.updated;
};

/**
 * Check whether user's country is US and has Sysco Products
 * @param {*} user
 * @param {*} syscoProducts
 * @returns isGlobalPriceEligible
 */
export const isGlobalPriceEligible = (user, syscoProducts) => {
  return user.get('country') === operatingCountries.unitedStates && !syscoProducts.isEmpty();
};

/**
 * Check whether app should fetch Sysco Products (US customer & no sysco products)
 * @param {*} user
 * @param {*} syscoProducts
 * @returns shouldFetchSyscoProducts
 */
export const shouldFetchSyscoProducts = (user, syscoProducts) => {
  return user.get('country') === operatingCountries.unitedStates && syscoProducts.isEmpty();
};

/**
 * Check the availability of the ingredient.
 * @param {*} ingredient
 * @returns true if the ingredient is available, otherwise false 
 */
export const isIngredientAvailable = (ingredient) => {
  return (!( ingredient.get('error') === PRICE_UNAVAILABLE_ERROR && ingredient.get('batchRecipeId') === -1 ));
};

/**
 * Check the batch recipe for a price unavailable error.
 * @param {*} recipe
 * @returns true if error exits, otherwise false 
 */
export const checkBatchRecipePriceError = (recipe) => {
  return ( recipe.get('error') === PRICE_UNAVAILABLE_ERROR && recipe.get('batchRecipeId') !== -1 );
};

/**
 * Check the recipe for an erronous price error.
 * @param {*} recipe
 * @returns true if error exits, otherwise false 
 */
export const isRecipePriceError = (recipe) => {
  return ( recipe.get('error') === ERRONEOUS_PRICE_ERROR );
};

/**
 * Check the menuItem for an erronous price error.
 * @param {*} recipe
 * @returns true if error exits, otherwise false 
 */
export const isMenuError = (menuItem) => {
  const menuItemRecipe = menuItem.get('recipes') && menuItem.get('recipes').toJSON();
  const data = !!menuItemRecipe && menuItemRecipe[0];
  return ( !!data && !!data.error );
};